import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import { ToggleOff, ToggleOn } from "../SVG";
import Collapse from "@mui/material/Collapse";
import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import WebServiceContext from "../../webService/WebServiceContext";


type CardProps = {
    title:string
    type?:string //套用CSS樣式
    collapseDisabled?: boolean
    collapseControl: boolean
    children?: String | React.ReactNode
}



const CardBase  = (props:CardProps)=>{ 
    const ws = useContext(WebServiceContext)
    const [open, setOpen] = useState<boolean>(true)

    useEffect(()=>{
        ws.stateservice.InitState(props.title).then((res:boolean)=>{
            setOpen( res as boolean )
        })
        return
    },[])
   
    useEffect(()=>{
        setOpen(props.collapseControl)
    },[props.collapseControl])

    useEffect(()=>{
        ws.stateservice.setState(props.title, open)
    },[open])

    return (
        <section className={"card " + (props.type?props.type:"") +" "+ (open? "show":"hide") }>
            <div className="header">
                <div>
                    <label className="title">{props.title}</label>
                </div>
                {!props.collapseDisabled &&
                    <div 
                        className="toggle"
                        onClick={()=>{
                            setOpen(!open)
                        }}>
                    {
                        open?
                        <ToggleOn/>:
                        <ToggleOff/> 
                    }
                    </div>
                }
            </div>
            <div>
                {props.children}
            </div>
            <div>
         
            </div>
            
        </section>
    )
}

export default CardBase